import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import styled from "@xstyled/styled-components";

import { QuestionComponentProps } from "..";

import { Spacing, Text } from "@otta/design";
import { palette } from "@otta/design-tokens";
import { UserCvParsingStatusDocument } from "@otta/search/schema";
import { useQuery } from "@otta/search/apollo";
import { Spinner } from "@otta/search/components/Loading";

const Card = styled.div`
  background-color: ${palette.brand.white};
  border-radius: lg;
  padding: lg;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

export function PreferencesReview({
  setNextEnabled,
  setShowNegative,
}: QuestionComponentProps): React.ReactElement {
  const navigate = useNavigate();
  const { data, loading } = useQuery(UserCvParsingStatusDocument);

  useEffect(() => {
    if (!loading && data?.currentUser?.cvParsingStatus !== "COMPLETED") {
      navigate("/initial-preferences/cv-upload");
    }
  }, [data, navigate, loading]);

  useEffect(() => {
    // Enable navigation buttons
    setNextEnabled(false);
    setShowNegative?.(false);
  }, [setNextEnabled, setShowNegative]);

  if (loading) {
    return <Spinner />;
  }

  return (
    <Spacing size={3}>
      <Card>
        <Container>
          <Text>
            WIP. This is a placeholder component for reviewing preferences.
          </Text>
        </Container>
      </Card>
    </Spacing>
  );
}
